import React, { useEffect, useState } from 'react';
import './App.css';
import Games from './shared/db/Games';
import Game from './shared/model/Game';
import Team from './shared/model/Team';

const InlineEdit = ({ value, setValue }) => {
    const [editingValue, setEditingValue] = useState(value);

    const onChange = (event) => setEditingValue(event.target.value);

    const onKeyDown = (event) => {
        if (event.key === "Enter" || event.key === "Escape") {
            event.target.blur();
        }
    }

    const onBlur = (event) => {
        if (event.target.value.trim() === "") {
            setEditingValue(value);
        } else {
            setValue(event.target.value)
        }
    }

    return (
        <input
            type="text"
            className="input-player-name"
            value={editingValue}
            onChange={onChange}
            onKeyDown={onKeyDown}
            onBlur={onBlur}
        />
    );
};

function App() {
    const games = new Games();
    const [game, setGame] = useState(new Game());
    const [team1, setTeam1] = useState(new Team());
    const [team2, setTeam2] = useState(new Team());

    useEffect(function () {
        const cg = games.currentGame();
        setGame(cg);
        setTeam1(cg.teams[0])
        setTeam2(cg.teams[1])

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const saveGame = function () {
        setGame(previousState => {
            return Object.assign(new Game(), { ...previousState, ...game })
        });
        games.setCurrentGame(game);
    }

    const updateScore = function () {
        saveGame();
    }

    const upScore = function (team) {
        game.addScore(team);
        updateScore();
    }

    const downScore = function (team) {
        game.subScore(team);
        updateScore();
    }

    const changeInitialTeam = function () {
        if (game.totalPoints() > 0) {
            return;
        }
        game.setInitialTeam(game.initialTeam === 0 ? 1 : 0);
        updateScore();

        saveGame();
    }

    const resetScore = function () {
        game.resetGames();
        updateScore();
    }

    const updatePlayerName = function (player, name) {
        player.name = name;
        saveGame();
    }

    return (
        <div className="App">
            <header className="App-header">
                <table>
                    <thead>
                    <tr>
                        <th>
                            {team1 && team1.players && team1.players.map((player, itemKey) => {
                                return (<div key={'team1 ' + itemKey}>
                                    <InlineEdit value={player.name} setValue={(name) => {
                                        updatePlayerName(player, name)
                                    }}/>
                                </div>)
                            })}
                        </th>
                        <th></th>
                        <th>
                            {team2 && team2.players && team2.players.map((player, itemKey) => {
                                return (<div key={'team2 ' + itemKey}>
                                    <InlineEdit value={player.name} setValue={(name) => {
                                        updatePlayerName(player, name)
                                    }}/>
                                </div>)
                            })}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr className="Score-Data">
                        <td>
                            <a href="#change-up-score-team1" onClick={() => upScore(team1)}>{team1.currentScore}</a>
                        </td>
                        <td className="change-initial-team">
                            <a href="#change-initial-team" onClick={() => changeInitialTeam()}>
                                {game.currentTeam === 0 ? '⬅' : '➡'}
                            </a>
                        </td>
                        <td>
                            <a href="#change-up-score-team2" onClick={() => upScore(team2)}>{team2.currentScore}</a>
                        </td>
                    </tr>
                    <tr className="Down-Score">
                        <td>
                            <a href="#change-down-score-team1" onClick={() => downScore(team1)}
                               className="icon-big">🔽</a>
                        </td>
                        <td></td>
                        <td>
                            <a href="#change-down-score-team2" onClick={() => downScore(team2)}
                               className="icon-big">🔽</a>
                        </td>
                    </tr>
                    <tr className="Games-Data">
                        <td>
                            <a href="#show-games-team1">{team1.currentGames}</a>
                        </td>
                        <td></td>
                        <td>
                            <a href="#show-games-team2">{team2.currentGames}</a>
                        </td>
                    </tr>
                    </tbody>
                    <tfoot className="Actions-bottom">

                    <tr>
                        <td colSpan={3}>
                            <a href="#reset-games" onClick={() => resetScore()} className="icon-big">🔁</a>
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </header>
        </div>
    );
}

export default App;
